import type { FlowbiteCheckboxTheme } from 'flowbite-react';

const theme: FlowbiteCheckboxTheme = {
	root: {
		base: 'tw-h-4 tw-w-4 tw-rounded tw-border tw-border-gray-300 tw-bg-gray-100 focus:tw-ring-2 focus:tw-ring-primary-500 dark:tw-border-gray-700 dark:tw-bg-gray-700 dark:tw-ring-offset-gray-800 dark:focus:tw-ring-primary-500 tw-text-primary-500 checked:tw-bg-primary dark:checked:tw-bg-primary tw-p-2',
	},
};

export default theme;
